import { VIRTUAL_PROPS_ACCESSOR } from '@core/shared/virtual-properties';
import { MembershipRegistrationFormPrivateInsuranceSimpleComponent } from './registration-form.component';
import { PrivateInsuranceSimpleMembershipPlugin } from '@pflegetheke/membership-plugins-insurance/shared';
import { MembershipRegistrationPluginSummaryComponent } from '@common/membership/frontend-shared';
import { RouterLinkResolverService } from '@core/shared/feature';
import { Injector } from '@angular/core';
import { sharedInjectorForFrontend } from '@core/frontend-shared/providers';
import * as i0 from "@angular/core";
// NOTE: class has no provider. MembershipPluginsService.instancePlugins will use ModuleRef.create to instantiate it.
export let PrivateInsuranceSimpleFrontendMembershipPlugin = /*#__PURE__*/(() => {
  class PrivateInsuranceSimpleFrontendMembershipPlugin extends PrivateInsuranceSimpleMembershipPlugin {
    constructor(injector) {
      super(sharedInjectorForFrontend(injector));
    }
    getRegistrationComponent() {
      return MembershipRegistrationFormPrivateInsuranceSimpleComponent;
    }
    getSummaryComponent() {
      return MembershipRegistrationPluginSummaryComponent;
    }
    getAccountData(data) {
      return {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        username: data.email,
        // password will be generated on server side
        [VIRTUAL_PROPS_ACCESSOR]: {
          phone: data.phone,
          allow3rdPartyContact: data.allow3rdPartyContact
        }
      };
    }
    getDataToPersist(data) {
      return {
        insuranceId: data.insuranceId,
        insuranceMembershipId: data.insuranceMembershipId,
        address: data.address,
        zipcode: data.zipcode,
        city: data.city
      };
    }
    getCategorization(data) {
      return data.insuranceId;
    }
    getRegistrationCompletedButton() {
      const resolver = this.injector.get(RouterLinkResolverService);
      const link = resolver.resolveRouterLink('frontend', 'questionCategories');
      return {
        label: "Weiter zu den Videos",
        link
      };
    }
    static {
      this.ɵfac = function PrivateInsuranceSimpleFrontendMembershipPlugin_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PrivateInsuranceSimpleFrontendMembershipPlugin)(i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: PrivateInsuranceSimpleFrontendMembershipPlugin,
        factory: PrivateInsuranceSimpleFrontendMembershipPlugin.ɵfac
      });
    }
  }
  return PrivateInsuranceSimpleFrontendMembershipPlugin;
})();